import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("mt_token");
    if (!t) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      console.error("auth/me failed:", err);
      localStorage.removeItem("mt_token");
    }
    setLoading(false);
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const signup = async (email, password, display_name) => {
    const { data } = await api.post("/auth/signup", { email, password, display_name });
    localStorage.setItem("mt_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mt_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mt_token");
    sessionStorage.removeItem("mt_intro_seen");
    sessionStorage.removeItem("mt_last_level");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, signup, login, logout, refresh: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
